const EndorsementChainType = {
	INITIAL: "INITIAL",
	TRANSFER_HOLDER: "TRANSFER_HOLDER",
	TRANSFER_BENEFICIARY: "TRANSFER_BENEFICIARY",
	TRANSFER_OWNERS: "TRANSFER_OWNERS",
	SURRENDERED: "SURRENDERED",
	SURRENDER_REJECTED: "SURRENDER_REJECTED",
	SURRENDER_ACCEPTED: "SURRENDER_ACCEPTED",
	REJECT_TRANSFER_HOLDER: "REJECT_TRANSFER_HOLDER",
	REJECT_TRANSFER_BENEFICIARY: "REJECT_TRANSFER_BENEFICIARY",
	REJECT_TRANSFER_OWNERS: "REJECT_TRANSFER_OWNERS",
	RETURNED_TO_ISSUER: "RETURNED_TO_ISSUER",
	RETURN_TO_ISSUER_REJECTED: "RETURN_TO_ISSUER_REJECTED",
	RETURN_TO_ISSUER_ACCEPTED: "RETURN_TO_ISSUER_ACCEPTED"
}

export default EndorsementChainType
